import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { getCurrentEnvExpressApiUrl } from '../../configs/api/enviroments';
import { EXPRESS_API } from '../../configs/api/expressApi';
import { errorToast } from '../../toasts/error';
import { GenerateTextParams } from '../types';

interface MutationFnVariables {
  data: GenerateTextParams;
  signal: AbortSignal;
}

const generateTextStream = async (variables: MutationFnVariables) => {
  const { data, signal } = variables;
  const apiExpressUrl = getCurrentEnvExpressApiUrl();
  const headers = EXPRESS_API.defaults.headers.common;
  // using fetch api since axios doesn't support streaming
  const response = await fetch(`${apiExpressUrl}gpt/stream`, {
    method: 'POST',
    headers: {
      ...headers,
      'Content-Type': 'application/json',
    } as HeadersInit,
    body: JSON.stringify(data),
    signal,
  });
  if (!response.ok || !response.body) {
    throw response.statusText;
  }
  return response;
};

export const useGenerateTextStream = () => {
  const queryClient = useQueryClient();

  return useMutation(generateTextStream, {
    onError: (e: AxiosError) => {
      queryClient.invalidateQueries(['MAGIC_COUNT']);
      errorToast({
        title: e.message || 'Something went wrong generating text stream',
      });
    },
    onSuccess: () => queryClient.invalidateQueries(['MAGIC_COUNT']),
  });
};
